// src/store/contactsSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import apiInstance from "../../services/apiService";
import ENDPOINTS from "../../services/endpoint";

export interface Conversation {
  id: string;
  name: string;
  number: string | null;
  message: string;
  time: string;
  date: string;
  isPin: boolean;
  iseFone: boolean;
  isMuted: boolean;
  lastUpdateToSort: string;
  isGroup: boolean;
  image: string;
  isArchived: boolean;
  isBlocked: boolean;
  groupMembers: string[];
  unreadCount: number | null;
  fullName: string | undefined;
}

interface ContactsState {
  contacts: Conversation[];
  loading: boolean;
  error: string | null;
}

const initialState: ContactsState = {
  contacts: [],
  loading: true,
  error: null,
};

// async thunk to fetch contacts
export const fetchContacts = createAsyncThunk(
  "contacts/fetchContacts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(ENDPOINTS.CONTACTS_LIST);
      return response.data.data as Conversation[];
    } catch (err: any) {
      return rejectWithValue(err.msg || "Failed to fetch contacts");
    }
  }
);

const contactsSlice = createSlice({
  name: "contacts",
  initialState,
  reducers: {
    setContacts(state, action: PayloadAction<Conversation[]>) {
      state.contacts = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContacts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContacts.fulfilled, (state, action) => {
        state.contacts = action.payload;
        state.loading = false;
      })
      .addCase(fetchContacts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setContacts } = contactsSlice.actions;
export default contactsSlice.reducer;
